import React from 'react'


const Awards: React.FC = () => {
    return (
<React.Fragment>
<div className="flex flex-col justify-center items-center">
    
<h1 className="font-bold text-3xl text-center text-[#83cd9a]">Silver Medal</h1>
<div className="grid grid-cols-2 mb-16 w-[80%] h-full rounded gap-16">
    <img className="rounded-xl mt-16 aspect-square"src=" https://static.igem.wiki/teams/5058/novas-imagens/img-20241025-wa0404-2-1.webp " alt="" />
    <img className="rounded-xl mt-16 aspect-square" src="https://static.igem.wiki/teams/5058/novas-imagens/img-20241025-wa0405.webp " alt="" /><img className="rounded-xl mt-16 aspect-square" src=" https://static.igem.wiki/teams/5058/novas-imagens/img-20241028-181121-764.webp " alt="" />
   
    <img className="rounded-xl mt-16 aspect-square" src=" https://static.igem.wiki/teams/5058/novas-imagens/img-20241028-181121-857.webp " alt="" />
</div>
</div>
 </React.Fragment>
)
}

export default Awards
